import React from "react";
import { Box, Grid } from "@mui/material";
import { CommonTimePicker, CommonDropdown } from "./common";

const weekDays = [
  { name: "Monday", value: "Monday" },
  { name: "Tuesday", value: "Tuesday" },
  { name: "Wednesday", value: "Wednesday" },
  { name: "Thursday", value: "Thursday" },
  { name: "Friday", value: "Friday" },
  { name: "Saturday", value: "Saturday" },
  { name: "Sunday", value: "Sunday" },
];

export function SettlementCycle(props) {
  const {
    configData, onChangeHandler, TextFieldComponent, errorStatus,
  } = props;
  const type = configData.settlementCycle;
  return (
    <>
      <Grid container item alignItems="flex-end" spacing={3}>
        {type !== "Daily" && (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ fontWeight: "bold" }}>
                Settlement Cutoff
                {" "}
                {type === "Monthly" ? "Date" : "Day"}
              </Box>
            </Grid>
            <Grid item xs={12} sm={5} md={3}>
              <CommonDropdown
                required
                options={
                  type === "Monthly"
                    ? [...Array(28)].map((_, i) => ({
                      label: `${i + 1}`,
                      value: `${i + 1}`,
                    }))
                    : weekDays.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                }
                onChangeHandler={onChangeHandler}
                selectedValue={
                  type === "Monthly"
                    ? configData.settlementCutoffDate
                    : configData.settlementCutoffDay
                }
                inputLabel={`Cutoff ${type === "Monthly" ? "Date" : "Day"}`}
                name={
                  type === "Monthly"
                    ? "settlementCutoffDate"
                    : "settlementCutoffDay"
                }
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontWeight: "bold" }}>Settlement Cutoff Time</Box>
        </Grid>
        <Grid item xs={12} sm={5} md={3} className="customConfigWrapper">
          <CommonTimePicker
            requried
            name="settlementCutoffTime"
            value={configData.settlementCutoffTime}
            onChangeHandler={onChangeHandler}
            TextFieldComponent={TextFieldComponent}
          />
        </Grid>
      </Grid>
      <Grid container item alignItems="flex-end" spacing={3}>
        {type !== "Daily" && (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ fontWeight: "bold" }}>
                Settlement Run
                {" "}
                {type === "Monthly" ? "Date" : "Day"}
              </Box>
            </Grid>
            <Grid item xs={12} sm={5} md={3}>
              <CommonDropdown
                options={
                  type === "Monthly"
                    ? [...Array(28)].map((_, i) => ({
                      label: `${i + 1}`,
                      value: `${i + 1}`,
                    }))
                    : weekDays.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                }
                onChangeHandler={onChangeHandler}
                selectedValue={
                  type === "Monthly"
                    ? configData.settlementRunDate
                    : configData.settlementRunDay
                }
                inputLabel={`Run ${type === "Monthly" ? "Date" : "Day"}`}
                name={
                  type === "Monthly" ? "settlementRunDate" : "settlementRunDay"
                }
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ fontWeight: "bold" }}>Settlement Run Time</Box>
        </Grid>
        <Grid item xs={12} sm={5} md={3} className="customConfigWrapper">
          <CommonTimePicker
            name="settlementRunTime"
            value={configData.settlementRunTime}
            onChangeHandler={onChangeHandler}
            TextFieldComponent={TextFieldComponent}
          />
        </Grid>
      </Grid>
      {errorStatus.runTimeError && (
        <div
          style={{
            color: "red",
            fontWeight: 400,
            fontSize: "0.65rem",
            lineHeight: "1",
            letterSpacing: " 0.03333em",
            textAlign: "left",
            margin: "-10px 0 0 16px",
          }}
        >
          Settlement run time Should be ahead of cut off time
        </div>
      )}
    </>
  );
}
